export const SET_STATUS_PRESTA = 'SET_STATUS_PRESTA';